import { ConfigProvider, theme } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../contexts/AuthContext';
import './App.less';
import ProLayoutApp from './ProLayoutApp';

// Float UI Theme Configuration
const floatTheme = {
  algorithm: theme.defaultAlgorithm,
  token: {
    // Core Colors - Vibrant Indigo/Violet
    colorPrimary: '#4f46e5',
    colorPrimaryHover: '#4338ca',
    colorPrimaryActive: '#3730a3',
    
    // Typography
    fontFamily: "'Inter', 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,
    
    // Shapes & Layout
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 8,
    
    // Backgrounds
    colorBgLayout: 'transparent', // Allow body gradient to show
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    
    // Text
    colorTextBase: '#1e293b', // Slate 800
    colorTextSecondary: '#64748b', // Slate 500
    colorTextTertiary: '#94a3b8', // Slate 400
    
    // Borders
    colorBorder: '#e2e8f0',
    colorSplit: '#f1f5f9',
    
    // Shadow
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    boxShadowSecondary: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
  },
  components: {
    Button: {
      controlHeight: 40,
      borderRadius: 10,
      boxShadow: '0 4px 12px rgba(79, 70, 229, 0.2)',
      primaryShadow: '0 4px 14px rgba(79, 70, 229, 0.3)',
      defaultBorderColor: '#e2e8f0',
      defaultGhostColor: '#4f46e5',
    },
    Card: {
      headerBg: 'transparent',
      boxShadowTertiary: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    },
    Menu: {
      itemBorderRadius: 8,
      itemHeight: 40,
      itemSelectedBg: 'rgba(79, 70, 229, 0.1)',
      itemSelectedColor: '#4f46e5',
      itemHoverBg: 'rgba(79, 70, 229, 0.05)',
      activeBarHeight: 0, // Remove the default side bar
    },
    Layout: {
      headerBg: 'rgba(255, 255, 255, 0.7)',
      siderBg: 'rgba(255, 255, 255, 0.5)',
    },
    Input: {
      controlHeight: 42,
      activeBorderColor: '#4f46e5',
      hoverBorderColor: '#818cf8',
      borderRadius: 10,
    },
    Select: {
      controlHeight: 42,
      borderRadius: 10,
    },
    Table: {
      headerBg: 'rgba(248, 250, 252, 0.5)',
      headerColor: '#64748b',
      rowHoverBg: 'rgba(241, 245, 249, 0.6)',
    },
    Modal: {
      contentBg: 'rgba(255, 255, 255, 0.95)',
      headerBg: 'transparent',
    }
  }
};

const App = () => {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={floatTheme}
    >
      <BrowserRouter>
        <AuthProvider>
          <ProLayoutApp />
        </AuthProvider>
      </BrowserRouter>
    </ConfigProvider>
  );
};

export default App;
